/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getAllBots = () => {
  return API.get(`${getApiUrl()}/api/bot/get-all`);
}

export const botService = {
  getAllBots
}
